import { AveliosButton } from '@components/common-layout/avelios-button';
import { Modal } from 'antd';
import { jsPDF } from 'jspdf';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import QRCode from 'react-qr-code';

interface QrCodeModalProps {
  id: string;
  open: boolean;
  onClose: () => void;
}

export const QrCodeModal: FC<QrCodeModalProps> = ({ id, open, onClose }) => {
  const { formatMessage } = useIntl();

  const downloadQRCode = () => {
    const svg = document.getElementById('qr-code');
    const svgData = new XMLSerializer().serializeToString(svg!);
    const blob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    // Draw the SVG image onto the canvas
    const img = new Image();
    img.src = url;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      if (ctx) {
        canvas.width = 300;
        canvas.height = 300;

        ctx.drawImage(img, 0, 0);
        const imgData = canvas.toDataURL('image/png');

        const pdf = new jsPDF();
        pdf.addImage(imgData, 'PNG', 70, 50, 80, 80);
        pdf.save('QR-Code-' + id);
      } else {
        console.error('Download error: ctx could not be obtained');
      }
    };
  };

  return (
    <Modal
      footer={false}
      closable
      open={open}
      onCancel={onClose}
      title={formatMessage({ id: 'action.show-qr-code' })}
    >
      <div style={{ textAlign: 'center', marginBottom: 22 }}>
        <QRCode value={id} id={'qr-code'} />
      </div>
      <div style={{ textAlign: 'center' }}>{id}</div>
      {id && (
        <AveliosButton
          block
          type={'primary'}
          style={{ marginTop: 20 }}
          onClick={() => downloadQRCode()}
        >
          {formatMessage({ id: 'action.download' })}
        </AveliosButton>
      )}
    </Modal>
  );
};
